export default __webpack_public_path__ + "static/media/dots.02b5938a.svg";